import React, { Component } from 'react'
import { Paper, TextField, Typography } from '@material-ui/core'
import * as defs from './PurchaseOrder.module.scss'

import { withStyles } from '@material-ui/styles';

const styles = {
  input: {
    '& input[type=number]': {
      textAlign: 'right',
      '-moz-appearance': 'textfield'
    },
    '& input[type=number]::-webkit-outer-spin-button': {
        '-webkit-appearance': 'none',
        margin: 0
    },
    '& input[type=number]::-webkit-inner-spin-button': {
        '-webkit-appearance': 'none',
        margin: 0
    }
  },
};

const calculateSubtotal = lineItems => (lineItems || []).reduce((sum, li) => sum + (parseFloat(li.cost) * parseFloat(li.quantity)), 0)

class PurchaseOrderTotals extends Component {

  constructor(props) {
    super(props)
    this.state = {
      subtotal: 0,
      vatPercent: 0.0,
      vat: 0,
      total: 0,
    }
    this.onChangeVatPercent = this.onChangeVatPercent.bind(this)
  }

  componentDidMount() {
    const { purchaseOrder: { lineItems, vat, vatPercent, total } = {} } = this.props;
    const subtotal = calculateSubtotal(lineItems);
    this.setState({
      subtotal,
      vatPercent: vatPercent || 0.0,
      vat: vat || 0,
      total: total || 0,
    })
  }

  componentDidUpdate(prevProps, prevState) {
    const { purchaseOrder: { lineItems, vatPercent } = {} } = this.props;
    const { purchaseOrder: { lineItems: _lineItems, vatPercent: _vatPercent } = {} } = prevProps;
    const subtotal = calculateSubtotal(lineItems);
    if (subtotal != prevState.subtotal || vatPercent != _vatPercent) {
      this.setStateFromVatAndSubtotal(vatPercent, subtotal)
    }
  }

  setStateFromVatAndSubtotal(vatPercent, subtotal) {
    const vat = ((vatPercent || 0) / 100 * subtotal);
    const total = subtotal + vat;
    const { onUpdate } = this.props;
    this.setState({
      subtotal,
      vatPercent,
      vat,
      total
    })
    if (onUpdate) onUpdate({subtotal, vatPercent, vat, total})
  }

  onChangeVatPercent(event) {
    const vatPercent = event.target.value;
    const { subtotal } = this.state;
    this.setStateFromVatAndSubtotal(vatPercent, subtotal);
  }

  render() {

    const { subtotal, vat, vatPercent, total } = this.state;
    const { classes, isEditing } = this.props;

    return (
      <Paper style={{ margin: 16, padding: '8px 16px 16px', maxWidth: '405px'}}>
        <Typography variant='overline'>
          Totals
        </Typography>
        <div className={defs.subtotal}>
          <span className={defs.totalsLabel}>Subtotal: </span>
          <span className={defs.totalsValue}>£{subtotal.toFixed(2)}</span>
        </div>
        <div className={defs.vatPercent}>
          <span className={defs.totalsLabel}>VAT rate: </span>
          <span className={defs.totalsValue}>
            { !isEditing && `${vatPercent}` }
            { isEditing && 
              <TextField
                type="number"
                name="VAT rate"
                className={classes.input}
                value={vatPercent}
                placeholder="20"
                className={defs.vatRateField}
                InputProps={{
                  minimum: 0,
                  maximum: 100,
                  disableUnderline: true
                }}
                inputProps={{ style: { textAlign: 'right', fontSize: '20px' } }}
                InputLabelProps={{ shrink: true }}
                onChange={this.onChangeVatPercent}
              />
            }
             %
          </span>
        </div>
        <div className={defs.vat}>
          <span className={defs.totalsLabel}>VAT: </span>
          <span className={defs.totalsValue}>£{vat.toFixed(2)}</span>
        </div>
        <div className={defs.total}>
          <span className={defs.totalsLabel}>Total: </span>
          <span className={defs.totalsValue}>£{total.toFixed(2)}</span>
        </div>
      </Paper>
    )
  }
}

export default withStyles(styles)(PurchaseOrderTotals)